import React, { useEffect } from "react";
// Added by Gauri to navigate to Signin page on 07 Nov 2025
import { useNavigate } from "react-router-dom";
// Logo Added By Madhuri.K On 03-03-2025
import logo from "../../assets/img/Ini_Logo_1.png";
// Added by Gauri on 07 Nov 2025
import { Box, Typography } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const UnauthorizedPage = () => {
  const navigate = useNavigate();   // Added by Gauri to navigate to Signin page on 07 Nov 2025

  // Added by Gauri to navigate to Signin page on 07 Nov 2025
  const handleBackToLogin = () => {
    navigate("/signin");
  };

  // Added to redirect to signin page after 5 seconds on 18 Nov 2025
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/signin");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: "20px",
        backgroundColor: "#f9f9f9", // Optional: for better visibility
        height: "100vh" // Full viewport height
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        {/* You can replace the following div with your icon component */}
        <div
          style={{
            fontSize: "64px", // Adjust size as needed
            color: "grey" // Icon color
          }}
        >
          🔒
        </div>
      </div>
      <p style={{ color: "grey", fontSize: "18px", margin: "10px 0" }}>You are not authorized</p>
      <p style={{ color: "lightblue", fontSize: "16px", margin: "10px 0" }}>
        It seems you don't have permission to use the App
      </p>
      <p style={{ color: "lightblue", fontSize: "16px", margin: "10px 0" }}>
        Please contact Whizible Administrator for more detail
      </p>
      <img
        src={logo} // Replace with your image path
        alt="Unauthorized Access" style={{ margin: "-14px 0" }}
      />

      {/* Added by Gauri to navigate to Signin page on 07 Nov 2025 */}
      {/* Commented by Gauri on 18 Nov 2025 */}
      {/* <button
        onClick={handleBackToLogin}
        style={{
          marginTop: "30px",
          padding: "12px 24px",
          fontSize: "16px",
          backgroundColor: "#1976d2",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: "500",
          transition: "background-color 0.3s ease",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#1565c0";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#1976d2";
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 16, mr: 1, color: 'white' }} />
        Back to Login Page
      </button> */}
    </div>
  );
};

export default UnauthorizedPage;
